import {Filter} from '@shared/models/filter.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {DateUtilities} from '@shared/utilities/date-utilities.model';

export class UsersFilterModel extends Filter {
	search_text: string;
	firstname: string;
	lastname: string;
	username: boolean;
	is_active: boolean;
	created_from: string;
	created_to: string;

	constructor(model?: any) {
		super();
		if (!Utilities.isVoid(model)) {
			this.search_text = model.search_text;
			this.firstname = model.firstname;
			this.lastname = model.lastname;
			this.username = model.username;
			this.is_active = model.is_active;
			if (model.created_from instanceof Date) {
				this.created_from = DateUtilities.getStringFromDate(model.created_from, DateUtilities.onlyDate);
			} else {
				this.created_from = model.created_from;
			}
			if (model.created_to instanceof Date) {
				this.created_to = DateUtilities.getStringFromDate(model.created_to, DateUtilities.onlyDate);
			} else {
				this.created_to = model.created_to;
			}
		}
	}

	newFilter(model?: any): UsersFilterModel {
		return new UsersFilterModel(model);
	}

	clone(): UsersFilterModel {
		return new UsersFilterModel(this);
	}

	public getFilterUrl(): string {
		let filterUrl = Utilities.getQuery(this);
		if (!Utilities.isVoid(this.created_from) && Utilities.isVoid(this.created_to)) {
			filterUrl += '&created_to=31/12/2099';
		}
		if (!Utilities.isVoid(this.created_to) && Utilities.isVoid(this.created_from)) {
			filterUrl += '&created_from=01/01/1900';
		}
		return filterUrl;
	}
}
